import styled, { css } from '@kawaui/theme'

export const Wrapper = styled.div<{ hasCursor: boolean }>`
  ${({ hasCursor }) =>
    hasCursor &&
    css`
      &:hover {
        cursor: pointer;
      }
      a {
        text-decoration: none;
      }
    `}
`
